<app-main-nav (closeDrawer)="closeDrawer.emit()" />

<div class="buttons-container">
  @if (isNotExtraSmall()) {
    <div class="fix-menu-width">
      <button
        type="button"
        mat-icon-button
        [class.spin]="mainNavService.mainNavOpen()"
        (click)="fixSideNavOpen(); $event.preventDefault()">
        <mat-icon>keyboard_arrow_right</mat-icon>
      </button>
    </div>
  }

  <button type="button" mat-flat-button (click)="signOutButtonClicked()">
    <mat-icon>logout</mat-icon>
    <span [@animateText]="mainNavService.mainNavOpen() ? 'show' : 'hide'">Logout</span>
  </button>
</div>
